@if (!hideSigningFieldNote_() && !isSubmitting_()) {
	<ui-note
		title="Collect E-Signatures Fast Right Inside Closer"
		[type]="NOTE_TYPES.INFO"
		[callToActionType]="CALL_TO_ACTION_TYPES.CLOSE"
		(callToActionClick)="closeFieldNote()"
		[omitCloseLogic]="true"
	>
		<p class="text-gray-900 text-base">
			We pre-tag the signature fields, send the package, and keep you updated
			every step of the way.
		</p>

		<a
			href="https://www.closer.ca/features/e-signing"
			target="_blank"
			rel="noopener noreferrer"
			class="text-green-600 text-base underline cursor-pointer"
		>
			Learn More
		</a>
	</ui-note>
}

@if (isSubmitting_()) {
	<div class="flex flex-col w-full items-center justify-center h-full p-20">
		<img
			alt="Envelope Creation"
			src="/assets/images/envelopes/envelope-creation.svg"
			class="max-w-72 mb-6"
			alt="Envelope creation illustration"
			loading="lazy"
		/>
		<h4 class="h4 text-center my-4 px-12">
			We’re preparing your documents and adding fillable signing fields
		</h4>
		<ui-progress-bar
			class="w-full"
			[percentage]="percentage_()"
			[message]="activeLoadingBlurb_()"
			messagePosition="center"
		/>
	</div>
}
<form
	[formGroup]="form"
	class="flex flex-col"
	[ngClass]="{
		'hidden size-0': isSubmitting_(),
	}"
>
	<div class="flex flex-col justify-between flex-1">
		<div class="flex flex-col gap-4 overflow-y-auto">
			<div class="flex flex-col gap-2">
				<p class="text-lg">Review {{ title$ | async }}</p>
				<p class="text-sm text-gray-500 text-pretty">
					Review and update emails as needed. Use the toggle to include or
					exclude signers.
				</p>
			</div>

			<app-e-signing-recipient-list
				[form]="form"
				[submitted_]="hasSubmitted_()"
				[recipients]="recipients"
			/>
		</div>
	</div>
</form>
